<p-panel class="our-form-background">
  <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
    <div class="col">
      <h3 style="margin-bottom: 0 !important;">
        <span style="margin-left: 15px;">
          <fa-icon [icon]="['fad', 'graduation-cap']"> </fa-icon> <span class="hide-on-small-screens"> Training Record for</span> {{ operative?.firstName }} {{ operative?.lastName}}
        </span>
      </h3>
    </div>
    <div class="col pull-right">
      <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openTrainingRecordDetailsHelp()">
      </app-eca-ghost-btn>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <app-detail-container #trDetailsContainerComponent [containerHeader]="trDetailsContainerHeader" [collapsedContainerHeader]="trDetailsCollapsedContainerHeader"
                                [containerHeaderAction]="trDetailsAction">
            <ng-template #trDetailsContainerHeader>
              Training Record Details
            </ng-template>

            <ng-template #trDetailsCollapsedContainerHeader>
              Training Record Details
            </ng-template>

            <ng-template #trDetailsAction>
              <app-eca-ghost-btn class="title-action-button float-right" btnText="Edit" btnIcon="edit"
                                 btnType="primary" [disable]='isTrainingRecordLoading'
                                 *ngIf="!editingDetails"
                                 (btnClicked)="editDetails()"></app-eca-ghost-btn>
              <span class="float-right" *ngIf="editingDetails">
                <app-eca-ghost-btn btnText="Save" btnIcon="save" btnType="success"
                                   [disable]='isTrainingRecordLoading' (btnClicked)="saveDetails()"></app-eca-ghost-btn>
                <app-eca-ghost-btn btnText="Cancel" btnIcon="times" btnType="danger"
                                   [disable]='isTrainingRecordLoading' (btnClicked)="cancelEdit()"></app-eca-ghost-btn>
              </span>
            </ng-template>
            <div *ngIf="isTrainingRecordLoading" class="text-center">
              <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
            </div>
            <div *ngIf="!isTrainingRecordLoading">
              <div class="col">
                <app-training-record-editor *ngIf="tempTrainingRecord" [trainingRecord]="tempTrainingRecord" [trainingTypes]="trainingRecordTypes" (saveNewTrainingTypeRequested)="saveNewCompanyTrainingType($event)"
                                            [editing]="editingDetails"></app-training-record-editor>
              </div>
            </div>
          </app-detail-container>
        </div>
      </div>
    </div>
    <div class="container-fluid" style="margin-top: 1rem; margin-bottom: 200px; min-height: 400px">
      <div class="row">
        <div class="col">
          <p-tabView #memberTabs [styleClass]="'eca-tabs'">
            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-file'></i>
                <span class="tab-title">Documents</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <div *ngIf="isTrainingRecordLoading" class="text-center">
                    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                  </div>
                  <div *ngIf="!isTrainingRecordLoading">
                    <app-documents-list [showCount]="true" [allowedOperations]="loggedInUser?.documentOperations"
                                        [headerText]="'Documents'"
                                        [addDocumentButtonText]="'Add'" [documents]="trainingRecordDocuments"
                                        [showTableCaption]="true" (addDocument)="addTrainingRecordDocument()"
                                        (downloadDocument)="downloadTrainingRecordDocument($event)"
                                        (viewDocument)="viewTrainingRecordDocument($event)"
                                        (deleteDocument)="deleteTrainingRecordDocumentClick($event)"
                                        (editDocument)="editTrainingRecordDocument($event)"
                                        (openDocument)="openTrainingRecordDocument($event)" (refreshDocumentsRequested)="getTrainingRecordDocuments($event)">

                    </app-documents-list>
                  </div>
                </div>
              </div>
            </p-tabPanel>

            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-eye'></i>
                <span class="tab-title">Observations</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <div *ngIf="isTrainingRecordLoading" class="text-center">
                    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                  </div>
                  <div *ngIf="!isTrainingRecordLoading">
                    <app-observations-list [observations]="trainingRecordObservations" [allowedOperations]="loggedInUser?.trainingRecordOperations" [companyId]="this.companyId"
                                           (createObservationClicked)="createOrEditObservation($event,  true, 'Add Observation to the Training Record', ObservationType.TrainingRecord, true)"
                                           (viewObservationClicked)="createOrEditObservation($event, false, 'Training Record Observation ' , ObservationType.TrainingRecord)"
                                           (editObservationClicked)="createOrEditObservation($event, true, 'Training Record Observation' )"></app-observations-list>
                  </div>
                </div>
              </div>
            </p-tabPanel>

            <!-- </div> -->
          </p-tabView>
        </div>
      </div>
    </div>
  </ng-template>
</p-panel>
